<template>
    <container>
        <div slot="left_box_content">
            <component :is="curLeftComponent" ></component>
        </div>
        <div slot="right_box_content">
            <component :is="curRightComponent" ></component>
        </div>
        <div slot="bottom_box_content">
            <component :is="curBottomComponent"></component>
        </div>
    </container>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
import supplierReconciliationStoreModule from '@/store/modules/reconciliationsupplier'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    Left: () => import('./components/SupplierLeft'),
    Right: () => import('./components/Right'),
    Bottom: () => import('./components/SupplierBottom')
  },
  created () {
    // 注册动态store模块
    this.$store.registerModule('supplierReconciliation', supplierReconciliationStoreModule)
  },
  mounted () {
    this.setLeftComponent('Left')
    this.setShowLeftBlock(true)
    this.setRightComponent('Right')
    this.setShowRightBlock(true)
    this.setBottomHeight('90%')
    this.setBottomComponent('Bottom')
    this.setShowMap(false)
  },
  destroyed () {
    // 卸载动态store模块
    this.$store.unregisterModule('supplierReconciliation')
  }
}
</script>
